<template>
  <div class="contract-info-bd">
    <div class="info-wrap">
      <div class="item-onfo">
        <h1 class="sub-title">{{ $t('crm_contract_info_frame.ji_chu_xin_xi') }}</h1>
        <ul class="ubw">
          <li>
            <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_info_frame.he_tong_zhuang_tai') }}：</span>
            <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_info_frame.ding_dan_zhuang_tai') }}：</span>
            <span>{{ getDicValue('crm_contract_biz_state', detail.bizState) }}</span>
          </li>
          <li>
            <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_info_frame.he_tong_lei_xing') }}：</span>
            <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_info_frame.ding_dan_lei_xing') }}：</span>
            <span>{{ getDicValue('crm_contract_type', detail.bizClass) }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info_frame.qian_ding_ri_qi') }}：</span>
            <span>{{ $momentLocal(detail.signingDate, 'YYYY-MM-DD') || '/' }}</span>
          </li>
          <li>
            <span class="label" v-if="bizClassType === 'contract'">{{ $t('crm_contract_info_frame.he_tong_bian_hao') }}：</span>
            <span class="label" v-if="bizClassType === 'order'">{{ $t('crm_contract_info_frame.ding_dan_bian_hao') }}：</span>
            <span>{{ detail.contractNo }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info_frame.sghth') }}：</span>
            <span>{{ detail.customContractNo }}</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info_frame.he_tong_qi_xian') }}：</span>
            <span>{{ detail.signingDuration }} ({{ $t('crm_contract_info_frame.yue') }})</span>
          </li>
          <li>
            <span class="label">{{ $t('crm_contract_info_frame.sheng_xiao_ri_qi') }}：</span>
            <span>{{ $momentLocal(detail.effectiveDate, 'YYYY-MM-DD') || '/' }}</span>
          </li>
        </ul>
      </div>
      <div class="item-company">
        <div class="ub">
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_contract_info_frame.jia_fang_xin_xi') }}</h1>
            <ul>
              <li>
                <span class="label">{{ $t('crm_contract_info_frame.jfsqdb') }}</span>
                <span>{{ detail.partyAName }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_frame.ye_wu_fu_ze_ren') }}</span>
                <span>{{ detail.salesman }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_frame.lian_xi_dian_hua') }}</span>
                <span>{{ detail.salesmanPhone }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_frame.sqdbdz') }}</span>
                <span>{{ detail.partyAAddress }}</span>
              </li>
            </ul>
          </div>
          <div class="ub-f1">
            <h1 class="sub-title">{{ $t('crm_contract_info_frame.yi_fang_xin_xi') }}</h1>
            <ul style="margin-bottom: 24px">
              <li>
                <span class="label">{{ $t('crm_contract_info_frame.yfsqdb') }}</span>
                <span>{{ detail.customerName }}</span>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_frame.xiang_mu_fu_ze_ren') }}</span>
                    <span>{{ detail.projectContactName }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_frame.lian_xi_dian_hua') }}</span>
                    <span>{{ detail.projectContactPhone }}</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_frame.shou_quan_dai_biao') }}</span>
                    <span>{{ detail.signerName }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_frame.lian_xi_dian_hua') }}</span>
                    <span>{{ detail.signerPhone }}</span>
                  </div>
                </div>
              </li>
              <li>
                <div class="ub">
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_frame.fa_ren_xing_ming') }}</span>
                    <span>{{ detail.legalPerson }}</span>
                  </div>
                  <div class="ub-f1">
                    <span class="label">{{ $t('crm_contract_info_frame.frsfzhm') }}</span>
                    <span>{{ detail.identityCard }}</span>
                  </div>
                </div>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_frame.yi_fang_di_zhi') }}</span>
                <span>{{ detail.customerAddress }}</span>
              </li>
              <li>
                <span class="label">{{ $t('crm_contract_info_frame.ji_tuan_gong_si') }}</span>
                <span>{{ detail.bigCustomerName }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="info-lease">
        <h1 class="sub-title">{{ $t('crm_contract_info_frame.zu_lin_fang_an') }}</h1>
        <custom-table :index="true" :data="schemeList" tableCode="contract_rent_scheme"></custom-table>
      </div>

      <div class="info-lease">
        <h1 class="sub-title">{{ $t('crm_contract_info_frame.hao_cai_bao_jia') }}</h1>
        <custom-table :index="true" :data="stuffList" tableCode="contract_stuff"></custom-table>
      </div>

      <div class="info-item">
        <h1 class="sub-title" style="margin-bottom: 0">{{ $t('crm_contract_info_frame.he_tong_fu_jian') }}</h1>
        <div style="margin-top: 2px">
          <t-upload type="file" v-model="contractFile" :bizId="contractId" bizType="crm.contract" :disabled="true"></t-upload>
        </div>
      </div>
    </div>
    <img-detail-dialog :bizData="certificateData" :title="$t('crm_contract_info_frame.jiao_yi_ping_zheng')" v-if="visible" @close="visible = false"></img-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';

export default {
  components: { tUpload },
  name: '',
  props: {
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
    rule: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      contractId: '',
      contractClass: '',
      schemeList: [], // 租赁方案
      stuffList: [], // 耗材报价
      certificateData: {},
      visible: false,
      contractFile: [],
      classMap: {
        leasing_contract: 20, // 租赁合同
        lease_renewal_contract: 21, // 续租租赁
        frame_contract: 30, // 框架协议
        frame_order: 31, // 协议订单
        trail_order: 10, // 试用订单
      },
      approveMap: {
        20: 'leasing_contract', // 租赁合同
        21: 'lease_renewal_contract', // 续租合同
        30: 'frame_contract', // 框架协议
        31: 'frame_order', // 协议订单
        10: 'trail_order', // 试用订单
      },
      contractBizClass: ['20', '21', '30'], // 合同类型的bizClass
      orderBizClass: ['10', '31'], // 订单类型的bizClass
      bizClassType: '', // 合同contract,订单order
    };
  },
  mounted: function () {
    this.contractId = this.getJump('contractId');
    this.contractClass = this.getJump('contractClass');
    if (this.contractBizClass.includes(this.contractClass)) {
      this.bizClassType = 'contract';
    }
    if (this.orderBizClass.includes(this.contractClass)) {
      this.bizClassType = 'order';
    }
    this.approveType = this.getJump('approveType');
    if (this.approveType && !this.contractClass) {
      this.contractClass = this.classMap[this.approveType];
    }
    if (!this.approveType && this.contractClass) {
      this.approveType = this.approveMap[this.contractClass];
    }
    this.getListScheme();
  },
  methods: {
    // 租赁计算
    computedNum: function (row, name) {
      // 累计押金
      if (name === 'depositFeeTotal') {
        row.depositFeeTotal = (+row.depositFee * +row.bookingNum).toFixed(2);
        return row.depositFeeTotal;
      }
      // 首期租金(合计)
      if (name === 'firstRentTotal') {
        row.firstRentTotal = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm) * +row.bookingNum).toFixed(2);
        return row.firstRentTotal;
      }
      // 首期需支付
      if (name === 'firstPay') {
        row.firstPay = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm) * +row.bookingNum + +row.depositFee * +row.bookingNum).toFixed(2);
        return row.firstPay;
      }
      // 租赁期数
      if (name === 'periodNum') {
        row.periodNum = Math.ceil(+row.rentalTerm / (+row.paymentPeriod || +row.rentalTerm || 0));
        return row.periodNum;
      }
      // 首期租金/台
      if (name === 'firstRent') {
        row.firstRent = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * (+row.paymentPeriod || +row.rentalTerm)).toFixed(2);
        return row.firstRent;
      }
      // 累计租金/台
      if (name === 'totalRent') {
        row.totalRent = ((parseFloat(row.unitPrice) + parseFloat(row.additionalFee || 0)) * +row.rentalTerm).toFixed(2);
        return row.totalRent;
      }
      return '';
    },
    // 租赁方案、耗材报价（不同合同字段使用不同）
    getListScheme: function () {
      this.$getJSON(apis.crmContractListScheme, { bizId: this.contractId, bizClass: this.contractClass }).then((res) => {
        const data = res.data;
        this.schemeList = data.goodsSkuList || [];
        this.stuffList = data.stuffList || [];
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.contract-info-bd {
  background-color: #ffffff;
  .contract-scheme {
    > div {
      width: 180px;
      margin-bottom: 10px;
      > p:first-child {
        font-weight: 500;
        font-size: 12px;
      }
      p {
        line-height: 20px;
      }
    }
  }
  .pay-info {
    display: flex;
    justify-content: flex-end;
    line-height: 36px;
    color: #495057;
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    & > div {
      margin-left: 20px;
      margin-right: 10px;
      span {
        color: red;
        font-size: 14px;
      }
    }
  }
  .title {
    line-height: 50px;
    height: 50px;
    padding-left: 20px;
    color: $title-color;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid #eef2f8;
  }
  .info-wrap {
    padding: 20px 24px;
    .sub-title {
      color: $title-color;
      font-size: 12px;
      line-height: 32px;
      font-weight: 500;
      margin-bottom: 4px;
    }
    .item-onfo {
      border-bottom: 1px solid #eef2f8;
      padding: 0 16px 12px;
      ul > li {
        width: 33.3%;
      }
    }
    .item-company {
      padding: 12px 16px;
      border-bottom: 1px solid #eef2f8;
      & > .ub > .ub-f1:first-child {
        padding-right: 20px;
        border-right: 1px solid #eef2f8;
        margin-right: 16px;
      }
    }
    .item-aftersale,
    .item-firstpay {
      padding: 12px 16px;
      border-bottom: 1px solid #eef2f8;
      & > .ub > .ub-f2 {
        padding-left: 48px;
      }
    }
    .info-lease {
      padding: 12px 16px;
    }
    .info-item {
      padding: 12px 16px;
      .el-upload-list {
        display: flex;
      }
      .el-upload-list__item {
        background: rgba(248, 249, 251, 1);
        line-height: 32px;
        height: 32px;
        color: #0d9ae0;
        width: 306px;
        border-radius: 2px;
        padding: 0 10px;
        margin-right: 14px;
        margin-top: 0;
        &:first-child {
          margin-top: 0;
        }
        i.el-icon-document {
          display: none;
        }
        a.el-upload-list__item-name {
          color: #0d9ae0;
        }
        i.el-icon-circle-check::before {
          color: #0d9ae0;
          font-family: 'icon';
          font-size: 12px;
          font-style: normal;
          margin-right: 4px;
          -webkit-font-smoothing: antialiased;
          content: '\e6ec';
        }
      }
    }
    ul > li {
      line-height: 23px;
      // height: 23px;
      color: #6c757d;
      font-size: 12px;
      .label {
        color: #495057;
        width: 120px;
        display: inline-block;
        vertical-align: top;
      }
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>
